import React from "react";
import "../../Components/PackingSection/PackingSection.css";
import FTowel from "../../Assets/FTowel.jpg";
import Fjeans from "../../Assets/Fjeans.jpg";
import FPinktop from "../../Assets/FPinktop.jpg";
import shoesTowel from "../../Assets/Fshoes.jpg";

import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";

import HowDoesItWorks from "../HowDoesItWorks/HowDoesItWorks";
import bubble from "../../Assets/bubble.png";

export default function PackingSection() {
  gsap.registerPlugin(useGSAP, ScrollTrigger);
  useGSAP(() => {
    gsap.from(".imageWrapper", {
      scrollTrigger: {
        trigger: ".wavemain",
        scroller: "body",
        // markers: true,
        start: "top 20%",
        end: "bottom 108%",
        scrub: 1.5,
      },

      // scale: 0.2,
      opacity: 0,
      // y: "-150%",
    });
  });
  return (
    <div>
      <div className="wavemain">
        <div className="waavetextwrapper">
          <p className="waavetext">
            We offer a simple process to make your like easy
          </p>
        </div>
        <div className="foldedtextWrapper">
          <p className="foldedtext foldedtext1">Pristine</p>
          <p className="foldedtext foldedtext2">Fresh</p>
          <p className="foldedtext foldedtext3">Folded</p>
        </div>
        <div className="Foldedcontainer">
          <img src={FTowel} alt="Folded Towel" className="imageWrapper iw1" />
          <img src={Fjeans} alt="Folded Jeans" className="imageWrapper iw2" />
          <img
            src={FPinktop}
            alt="Folded Pink top"
            className="imageWrapper iw3"
          />
          <img src={shoesTowel} alt="Shoes" className="imageWrapper iw4" />
        </div>
      </div>
      <div className="absolute w-full h-[70%]">
        <img
          alt="Bubbel"
          src={bubble}
          className="h-[10vw] md:h-[5vw] absolute top-[15%]   left-[9vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[45vw] md:h-[25vw] absolute top-[-2%] md:top-[2%]  md:left-[52vw] left-[40vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[14vw] md:h-[35vw] absolute top-[50%] md:top-[25%]  left-[60vw] md:left-[50vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[19vw] md:h-[5vw] absolute top-[40%]   left-[12vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[38vw] md:h-[8vw] absolute top-[14%]   left-[28vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[61vw] md:h-[12vw] absolute top-[85%]   -left-[16vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[43vw] md:h-[11vw] absolute top-[96%]   left-[59vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[32vw] md:h-[22vw] absolute top-[19%] left-[-4vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[29vw] md:h-[14vw] absolute top-[75%]   left-[42vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[39vw] md:h-[9vw] absolute top-[56%]   left-[72vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[48vw] md:h-[14vw] absolute top-[62%] md:top-[12%]   left-[10vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[51vw] md:h-[13vw] absolute top-[19%]   left-[83vw]"
        />
        <img
          src={bubble}
          alt="Bubbel"
          className="h-[35vw] md:h-[30vw] absolute top-[51%]   left-[2vw]"
        />
      </div>
      <HowDoesItWorks />
    </div>
  );
}
